module.exports = __webpack_public_path__ + "static/img/02_07.47da267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20240913/02_07.png
// module id = f6eQ
// module chunks = 0